import { useState } from 'react';
import { featuredTopics } from '@/mocks/manga';

export default function FeaturedTopic() {
  const [active, setActive] = useState(featuredTopics[0].key);
  const topic = featuredTopics.find((t) => t.key === active) ?? featuredTopics[0];

  return (
    <section id="featured" className="mx-auto max-w-7xl scroll-mt-20 px-4 py-16 md:px-6 md:py-20">
      <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
        <div>
          <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
            <i className="ri-edit-2-fill" />
            编辑精选
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            值得一读的专题内容
          </h2>
          <p className="mt-3 max-w-2xl text-sm text-foreground-600">
            由编辑精心策划的系列专题，把同一主题的优质作品串联成一段完整的阅读旅程。
          </p>
        </div>
      </div>

      <div className="mt-8 inline-flex rounded-full bg-background-100 p-1">
        {featuredTopics.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => setActive(t.key)}
            className={`cursor-pointer whitespace-nowrap rounded-full px-5 py-2 text-sm transition-colors ${
              active === t.key
                ? 'bg-primary-500 text-background-50'
                : 'text-foreground-600 hover:text-primary-700'
            }`}
          >
            {t.name}
          </button>
        ))}
      </div>

      <p className="mt-4 text-sm text-foreground-600">{topic.intro}</p>

      <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-3">
        {topic.items.map((item) => (
          <article
            key={item.title}
            className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-200"
          >
            <div className="relative overflow-hidden">
              <img
                src={item.cover}
                alt={`${item.title} 专题作品封面`}
                className="aspect-[3/4] w-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-medium text-primary-700">
                {item.chapters}
              </span>
            </div>
            <div className="p-5">
              <h3 className="font-heading text-lg font-bold text-foreground-900">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              <div className="mt-3 flex flex-wrap gap-2">
                {item.tags.map((t) => (
                  <span
                    key={t}
                    className="rounded-full bg-accent-100 px-2.5 py-0.5 text-xs text-accent-800"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}